import React from "react";
import { useState } from "react";
import { Fragment } from "react";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import "react-toastify/dist/ReactToastify.css";
import "./LearnMore.css";

import { Button } from "react-bootstrap";

const ROOT_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";

const CONTENT = {
  ICE_RINK: [
    [
      {
        category: "Ice Rinks",
        title: "No Tools",
        content:
          "No tools required whatsoever. No hammers, drills, saws, screws, nails, or stakes. No trips to the hardware store, no bruised thumbs and no frozen hands trying to hold tools.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/No Tools - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/No Tools - 1080x1920px.webp",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Patented Strap System",
        content:
          "At the heart of EZ ICE is the patented strap system, designed with simplicity and efficiency in mind. Say goodbye to the hours spent hammering stakes into hard, frozen ground. The straps clip together seamlessly, without compromising on stability.",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/ValueProposition_Strap System_NOLOGO_V3.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/ValueProposition_Strap System_NOLOGO_9x16_V2.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "60 Minute Assembly",
        content:
          "It's in the name. EZ ICE Rinks are incredibly easy to assemble, with some taking as little as 5 minutes, so you can spend more time skating on your rink and less time assembling it.",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_63_60MinAssembly_V2.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/21c4f642ba2a424c80eaecd1f644ba33.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Any Surface",
        content:
          "Lawns, parking lots, sport courts, patios, driveways, and fields. No stakes are needed so EZ ICE Rinks can be assembled on any surface – even once your lawn has frozen solid!",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_66_AnySurface_V2.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/82cf79e802114ebfa0883acaa7c7dcd0.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Winter Fun",
        content:
          "Winter doesn't have to mean staring at phones, tablets, and other screens all day long. With EZ ICE, your kids will trade in their screen time for ice time!",
        video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel64_V1.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel64_9x16_V2.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Make Memories",
        content:
          "There's nothing like quality family time under the lights. Lace up the skates and make memories that will last a lifetime.",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_64_MakeMemories_V3.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/b6527590d9f14e68b25a41025f51f0dc.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Practice Makes Perfect",
        content:
          "Whether they're learning to skate or perfecting the Michigan, there's no better way to get reps in than a rink right in the backyard.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Practice Makes Perfect Graphic FINAL.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Practice Makes Perfect Graphic (9 x 16 in) (3).webp",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Expertly Engineered",
        content:
          "Our team of engineers, hockey players, and experienced rink builders designed the PRO Home Arena System® to create a premiere outdoor skating experience, with the majority of parts being designed and manufactured in the United States. ",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_68_ExpertlyEngineered_V2.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_68_ExpertlyEngineered_9x16_V3.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Durable Materials",
        content:
          "EZ ICE Rinks are crafted from the same high-quality material as NHL boards, designed to withstand the harshest winters and the toughest slapshots. Built to endure, EZ ICE Rinks provide over a decade of reliable performance so your family can enjoy time on the ice year after year. ",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_67_Durability_V2.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/8903efe2aaab44ec98e3eace66b12f68.mp4",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Customized for You",
        content:
          "Design your rink with your specific needs in mind. Rinks can be any size and any height so that they can be enjoyed by any age and all abilities. ",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Customizable Rink - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Customizable Rink -  1080x1920px.webp",
        padding: "p-6",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Easily Upgrade",
        content:
          "Easily upgrade your rink as your family and needs grow. Go wider, longer, and taller when you are ready by adding more boards and nets.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Upgrade Ice Desktop (1).png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Upgrade Ice (9 x 16 in) (1).webp",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Why EZ ICE",
        content: "Trusted by over 10,000 families across North America.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Rink Comparison Chart - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Rink Comparison - 1080x1920px.webp",
        padding: "p-10",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "Requirements",
        content:
          "We're here to make it easy for you. Wondering what you'll need to set up your rink? As long as your space meets these requirements, you're good to go. We'll take care of the rest.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Ice Rink Requirements - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Ice Rink Requirements - 1080x1920px.webp",
        padding: "p-6",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "How it Works",
        content:
          "The Patented PRO Home Arena System includes the boards, brackets, straps, and optional nets that form the foundation for any ice, Synthetic Ice, or Street Hockey rinks.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Ice Rinks - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Ice Rinks - 1080x1920px.webp",
        padding: "p-6",
      },
    ],
  ],
  SYNTHETIC_RINK: [
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Off the Device",
        content:
          "No more fighting with your kids to get off their screens. They'll want to get on the ice and improve their hockey skills when at home.",
        video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel68_V1.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel68_9x16.mp4",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Practice Makes Perfect",
        content:
          "During a hockey game, even the best players only touch the puck for about a minute.\nIt's important they make the most of that minute. EZ ICE Synthetic Ice helps players improve their skills any time of year",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Practice Makes Perfect Graphic FINAL (1).png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Practice Makes Perfect Graphic (9 x 16 in) (2) (1).webp",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Make Memories",
        content:
          "Memories of playing hockey shouldn't be limited to winter time. Make memories with friends and family any time of year, indoor or outdoor.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/make memories street 821.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/146A1425_9x16.webp",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Durable Materials",
        content:
          "EZ ICE Rinks are crafted from the same high-quality material as NHL boards, designed to withstand the harshest winters and the toughest slapshots. Built to endure, EZ ICE Rinks provide over a decade of reliable performance so your family can enjoy time on the ice year after year. ",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_67_Durability_V2.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/8903efe2aaab44ec98e3eace66b12f68.mp4",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Just Like the Real Thing",
        content:
          "Nothing can compare to skating on real ice, but EZ ICE Synthetic Ice is the next best thing. Infused with a glide agent, the Synthetic Ice is designed so you can glide and stop just like on real ice.\nThe dovetail joints prevent gaps, allowing for a smooth skating experience.",
        video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel69_V1.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel69_9x16.mp4",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Why EZ ICE",
        content: "Trusted by over 10,000 families across North America.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Why Synthetic Ice - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Why Synthetic Ice - 1080x1920px.webp",
        padding: "p-10",
      },
    ],
    [
      {
        category: "Synthetic Ice Rinks",
        title: "Requirements",
        content:
          "We're here to make it easy for you. Wondering what you'll need to set up your rink? As long as your space meets these requirements, you're good to go. We'll take care of the rest.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Synthetic Ice Requirements - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Synthetic Ice Requirements - 1080x1920px.webp",
        padding: "p-16",
      },
    ],
    [
      {
        category: "Ice Rinks",
        title: "How it Works",
        content:
          "The Patented PRO Home Arena System includes the boards, brackets, straps, and optional nets that form the foundation for any ice, Synthetic Ice, or Street Hockey rinks.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Synthetic Ice - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Synthetic Ice - 1080x1920px.webp",
        padding: "p-6",
      },
    ],
  ],
  STREET_HOCKEY_RINK: [
    [
      {
        category: "Street Hockey Rinks",
        title: "No Tools",
        content:
          "No tools required whatsoever. No hammers, drills, saws, screws, nails, or stakes. Anyone can do it!",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/No Tools - Street Hockey - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/No Tools -Street Hockey - 1080x1920px.webp",
        padding: "p-6",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Stress Free",
        content:
          "It's in the name. EZ ICE Rinks are incredibly easy to assemble, with some taking as little as 5 minutes, so you can spend more time out on the street playing, and less time assembling it.",
        video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel66_V3.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel66_9x16_V2.mp4",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Year Round Activity",
        content:
          "Get your kids off the devices. With EZ ICE, your kids will trade in their screen time for play time.",
        video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel65_V2.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel65_9x16_V3.mp4",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Make Memories",
        content:
          "10,000 families have experienced the magic of EZ ICE. Make your own memories that will last a lifetime.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/make memories street 821.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/146A1577-2_9x16.webp",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Practice Makes Perfect",
        content:
          "During a hockey game, even the best players only touch the puck for about a minute.\nIt's important they make the most of that minute. EZ ICE Street Hockey Rinks help players improve their skills any time of year.\nWhy wait for ice time to practice?",
        image: "https://d1cadrokl7e9dp.cloudfront.net/home/146A1544-2_16x9.jpg",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/146A1544-2_9x16.webp",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Play Anywhere",
        content:
          "Bring Street Hockey to your flat lawn or rough asphalt with Ultra Base panels. Simply lay tiles down to convert any flat, level, firm surface into your next Street Hockey pad.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Image resize  (2).png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/146A1662-2_9x16.webp",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Expertly Engineered",
        content:
          "Our team of engineers, hockey players, and experienced rink builders designed the PRO Home Arena System® to create a premiere outdoor skating experience, with the majority of parts being designed and manufactured in the United States. ",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_68_ExpertlyEngineered_V2.mp4",
        videoMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_68_ExpertlyEngineered_9x16_V3.mp4",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Durable Materials",
        content:
          "EZ ICE Rinks are crafted from the same high-quality material as professional boards, designed to withstand the toughest slapshots. Built to endure, EZ ICE Rinks provide over a decade of reliable performance so you can get extra play time in on the street.",
        video:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Reel_67_Durability_V2.mp4",
        videoMobile:
          "https://cdn.shopify.com/videos/c/o/v/8903efe2aaab44ec98e3eace66b12f68.mp4",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Easy Up, Easy Down",
        content:
          "With lightweight boards, EZ ICE Street Hockey rinks are perfect to set up and take down all in an afternoon.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Easy up easy down resize (1).png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Easy up easy down mobile  (1).webp",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Customized for You",
        content:
          "Design your rink with your specific needs in mind. Rinks can be any size and any height so that they can be enjoyed by any age and all abilities. ",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Custom street desktop.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/Customized Street Mobile (1).webp",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "Requirements",
        content:
          "We're here to make it easy for you. Wondering what you'll need to set up your rink? As long as your space meets these requirements, you're good to go. We'll take care of the rest.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Street Hockey Requirements - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ Ice - Street Hockey Requirements - 1080x1920px.webp",
        padding: "p-16",
      },
    ],
    [
      {
        category: "Street Hockey Rinks",
        title: "How it Works",
        content:
          "The Patented PRO Home Arena System includes the boards, brackets, straps, and optional nets that form the foundation for any ice, Synthetic Ice, or Street Hockey rinks.",
        image:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Street Hockey - 1920x1080px.png",
        imageMobile:
          "https://d1cadrokl7e9dp.cloudfront.net/home/EZ ICE 101 - Street Hockey - 1080x1920px.webp",
        padding: "p-6",
      },
    ],
  ],
};

function LearnMore(props) {
  const [row0Idx, setRow0Idx] = useState(0);
  const [row1Idx, setRow1Idx] = useState(0);
  const [row2Idx, setRow2Idx] = useState(0);
  const [row3Idx, setRow3Idx] = useState(0);
  const [row4Idx, setRow4Idx] = useState(0);
  const [row5Idx, setRow5Idx] = useState(0);
  const [row6Idx, setRow6Idx] = useState(0);
  const [row7Idx, setRow7Idx] = useState(0);
  const [row8Idx, setRow8Idx] = useState(0);
  const [row9Idx, setRow9Idx] = useState(0);
  const [row10Idx, setRow10Idx] = useState(0);
  const [row11Idx, setRow11Idx] = useState(0);
  const [row12Idx, setRow12Idx] = useState(0);
  const [row13Idx, setRow13Idx] = useState(0);
  const [row14Idx, setRow14Idx] = useState(0);
  const [row15Idx, setRow15Idx] = useState(0);
  const [row16Idx, setRow16Idx] = useState(0);

  const content = CONTENT[props.product];

  function redirectFromIframe(link) {
    window.parent.postMessage(
      {
        redirectUrl: link,
      },
      "*"
    );
  }

  return (
    <Fragment>
      {props.product === "ICE_RINK" && (
        <div>
          {window.innerWidth > 900 ? (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://d1cadrokl7e9dp.cloudfront.net/home/Reel74_V3_Desktop.mp4"
            ></video>
          ) : (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://cdn.shopify.com/videos/c/o/v/ff5a6055b5c4419aae780a72391df002.mp4"
            ></video>
          )}
        </div>
      )}
      {props.product === "SYNTHETIC_RINK" && (
        <div>
          {window.innerWidth > 900 ? (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://d1cadrokl7e9dp.cloudfront.net/home/EZICE_SYNTHETIC_FINAL_V3.mp4"
            ></video>
          ) : (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://d1cadrokl7e9dp.cloudfront.net/home/EZICE_SYNTHETIC_FINAL_9X16_V2.mp4"
            ></video>
          )}
        </div>
      )}
      {props.product === "STREET_HOCKEY_RINK" && (
        <div>
          {window.innerWidth > 900 ? (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://d1cadrokl7e9dp.cloudfront.net/home/EZ%20ICE_ST%20HOCKEY_MASTER.mp4"
            ></video>
          ) : (
            <video
              className="w-full bg-contain object-cover h-[100vh]"
              loop
              muted
              autoPlay
              playsInline
              preload="none"
              src="https://d1cadrokl7e9dp.cloudfront.net/home/EZ%20ICE_ST%20HOCKEY%20MASTER_16x9_V3.mp4"
            ></video>
          )}
        </div>
      )}

      {content.map((row, rowIdx) => {
        return (
          <div className="flex w-full learn-more-container border-solid border-b-2 border-white bk3:flex-col">
            <div
              className={`w-1/4 bk3:w-full relative ${
                rowIdx % 2 === 0 || window.innerWidth < 800
                  ? "order-1"
                  : "order-2"
              }`}
            >
              <div className="flex flex-col p-4 justify-between h-full">
                <div className="flex flex-col">
                  <div className="title-container border-b-2">
                    <div className="text-2xl bk1:text-xl text-gray-500 font-bold">
                      Learn More >{" "}
                      {content[rowIdx][eval("row" + rowIdx + "Idx")].category}
                    </div>
                    <h1 className="text-xl bk1:text-lg font-bold"></h1>
                  </div>
                  <div className="content-container mt-4">
                    <h1 className="text-2xl bk1:text-xl font-bold">
                      {content[rowIdx][eval("row" + rowIdx + "Idx")].title}
                    </h1>
                    <p className="mt-4 text-xl bk1:text-base text-gray-500">
                      {content[rowIdx][eval("row" + rowIdx + "Idx")].content}
                    </p>
                  </div>
                </div>
                <div className="flex w-full">
                  <Button
                    variant="danger"
                    className="w-full mt-auto rounded-lg text-xl bk1:text-lg p-0 bk3:w-[200px]"
                  >
                    {props.product === "ICE_RINK" && (
                      <div
                        className="text-white w-full h-full flex items-center justify-center p-2"
                        onClick={() =>
                          redirectFromIframe(
                            "https://ezicerinks.com/pages/ez-ice-rink-builder"
                          )
                        }
                      >
                        Build Your Rink
                      </div>
                    )}

                    {props.product === "SYNTHETIC_RINK" && (
                      <div
                        className="text-white w-full h-full flex items-center justify-center p-2"
                        onClick={() =>
                          redirectFromIframe(
                            "https://ezicerinks.com/pages/synthetic-rink-form"
                          )
                        }
                      >
                        Order Synthetic Ice
                      </div>
                    )}

                    {props.product === "STREET_HOCKEY_RINK" && (
                      <div
                        className="text-white w-full h-full flex items-center justify-center p-2"
                        onClick={() =>
                          redirectFromIframe(
                            "https://ezicerinks.com/pages/street-hockey-rink-form"
                          )
                        }
                      >
                        Build Your Rink
                      </div>
                    )}
                  </Button>
                </div>
              </div>
            </div>
            <div
              className={`flex w-3/4 bk3:w-full relative ${
                rowIdx % 2 === 0 || window.innerWidth < 800
                  ? "order-2"
                  : "order-1"
              }`}
            >
              {/* <div className="absolute left-8 top-1/2 transform -translate-y-1/2 z-50">
                                <button className="text-4xl font-bold text-white cursor-pointer slick-arrow slick-prev" onClick={() => toggleSlide(rowIdx, -1)}></button>
                                <div className="bg-black absolute h-[32px] w-[20px] left-[12px] top-[-5px]"></div>
                            </div>
                            <div className="absolute right-8 top-1/2 transform -translate-y-1/2 z-50">
                                <button className="text-4xl font-bold text-white cursor-pointer slick-arrow slick-next" onClick={() => toggleSlide(rowIdx, 1)}></button>
                                <div className="bg-black absolute h-[32px] w-[20px] right-[4px] top-[-5px]"></div>
                            </div> */}
              {content[rowIdx][eval("row" + rowIdx + "Idx")].image && (
                <div
                  className={`bg-[#E1E1E1] bk3:w-full ${
                    content[rowIdx][eval("row" + rowIdx + "Idx")].padding || ""
                  }`}
                >
                  <img
                    className="home-bg-video w-full bg-contain object-contain"
                    src={
                      window.innerWidth > 800
                        ? content[rowIdx][eval("row" + rowIdx + "Idx")].image
                        : content[rowIdx][eval("row" + rowIdx + "Idx")]
                            .imageMobile
                    }
                  />
                </div>
              )}

              {content[rowIdx][eval("row" + rowIdx + "Idx")].video && (
                <video
                  className="home-bg-video w-full bg-contain object-contain"
                  loop
                  muted
                  autoPlay
                  playsInline
                  preload="none"
                  key={content[rowIdx][eval("row" + rowIdx + "Idx")].video}
                >
                  <source
                    src={
                      window.innerWidth > 800
                        ? content[rowIdx][eval("row" + rowIdx + "Idx")].video
                        : content[rowIdx][eval("row" + rowIdx + "Idx")]
                            .videoMobile
                    }
                    type="video/mp4"
                  ></source>
                </video>
              )}
            </div>
          </div>
        );
      })}
      <ContactUs />
      <Footer />
    </Fragment>
  );
}

export default LearnMore;
